import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';


// All Extend comes here Loru...
dayjs.extend(utc);


export default dayjs;